// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/negative-balances/components/negative-balances-header/negative-balances-header.less
// module id = 3922
// module chunks = 0